<template>
  <div class="app__index">
    <v-app-bar
      v-if="!customToolbar"
      :app="!isMobile"
      flat
      height="auto"
      class="content__header"
      :class="{ centered }"
      id="app-bar"
    >
      <BackButton
        data-test="back-button"
        @click.native.stop="handleBack"
        v-if="isDetails"
      />
      <div data-test="skeleton-loader" v-if="isLoading">
        <v-skeleton-loader width="500" type="heading" />
      </div>
      <v-toolbar-title
        v-else-if="title"
        class="content__header__title"
        :class="{ 'small-title': smallTitle }"
        data-test="page-header"
      >
        <h1>{{ title }}</h1>
      </v-toolbar-title>
      <slot name="header" v-if="!isLoading" />
    </v-app-bar>
    <v-content class="main-content content-wrapper">
      <slot name="body" />
    </v-content>
  </div>
</template>

<script>
import BackButton from "@/components/common/Button/BackButton";

export default {
  props: {
    /**
     * String for title
     */
    title: {
      type: String,
      required: false
    },
    /**
     * Boolean set to true if details layout
     */
    isDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    /**
     * String for parent route
     */
    parent: {
      type: String,
      required: false
    },
    isLoading: Boolean,
    centered: Boolean,
    customToolbar: Boolean,
    smallTitle: Boolean
  },
  components: {
    BackButton
  },
  methods: {
    handleBack() {
      this.$router.push(this.parent);
    }
  }
};
</script>

<style lang="scss"></style>
